import { DividendListContainer } from './Container';

export const DividendList = DividendListContainer;
